const reloadPage = (): void => {
	window.location.reload();
};

export default reloadPage;
